<template>
  <div class="text-center py-24 text-red-500 dark:text-slate-400">
    <p>No tiene permisos para esta área …</p>
  </div>
</template>
